module.exports = __webpack_public_path__ + "static/media/pinterest.c2f7eee5.svg";